import React,{Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import {ToastProvider} from './common/component/Toast'
import { LoaderProvider } from './common/component/LoaderProvider';
import CommonLoader from './common/component/commonLoader';
import  fetchTranslations,{getTranslate}  from './service/action/actioncreator/CommonAction/Common';
import i18n from './common/translation/i18n';
import { initReactI18next } from 'react-i18next';
import ErrorBoundary from './common/component/errorBoundary';

const loadTranslations = async (language) => {
  try {
    const translations = await fetchTranslations();
    if (translations) {
      // Correct method: addResourceBundle
      i18n.addResourceBundle(language, 'translation', translations?.data?.it?.labels, true, true); 
    }

  } catch (error) {
    console.error('Error loading translations:', error);
  }
};
const root = ReactDOM.createRoot(document.getElementById('root'));
loadTranslations('it').then(() => {

root.render(
  // <React.StrictMode>
  <ToastProvider>
    <Suspense fallback={<p>Loading translations...</p>}>
    {/* <ErrorBoundary> */}
      <App />
      {/* </ErrorBoundary> */}
    </Suspense>
</ToastProvider>
  // </React.StrictMode>
);
})


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


